module.exports = __webpack_public_path__ + "img/face-4.5e913dec.png";